<!-- Copyright (c) 2023 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div>
    <span>Redirecting . . .</span>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
  },
  data: function() {
    return {
    };
  },
  props: {
  },
  methods: {
  },
  async mounted() {
    if (!this.$route.params.configCode) { // if no config code was provided
      this.$router.push('/'); // redirect to login page
      return;
    }

    const userKeys = Object.keys(localStorage).filter(key => key.match(/^u[0-9]/));
    const loggedInUserDetails = await this.$apiCallV2('/Login/GetLoggedInDetails', userKeys.map(u => {
      return {
        key: u,
        hash: localStorage.getItem(u)
      }
    }));
    const foundLoginSession = loggedInUserDetails.find((userDetails) => {
      return userDetails.configCode === this.$route.params.configCode; // try to find a login session with the same config code
    });

    if (!foundLoginSession) { // if there is no session with the same config code
      this.$router.push('/'); // redirect to login page
      return;
    }

    if (!this.$route.query.redirect) { // if no URL was passed to redirect to
      this.$router.push(`/Home/${foundLoginSession.userKey}`); // redirect to home page
      return;
    }

    const redirectURL = this.$route.query.redirect.replace("{user}", foundLoginSession.userKey);
    this.$router.push(redirectURL.startsWith("/") ? redirectURL : `/${redirectURL}`); // redirect to URL passed in query
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

</style>